/* Home: avvio dei video hover del navigatore. I <video> hanno preload="none" e nessun autoplay:
   qui partono in loop subito dopo il load, SOLO su desktop con mouse — così al primo hover il
   movimento è già in corso (priorità al design), mentre mobile/touch (dove i video sono nascosti)
   non scaricano nulla. Con prefers-reduced-motion resta il poster statico. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (reducedMotion || !finePointer) return;

  function start() {
    var bp = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--off-breakpoint-desktop')) || 1200;
    if (window.innerWidth < bp) return;
    document.querySelectorAll('.main-index__image video').forEach(function (video) {
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    });
  }

  function boot() {
    var idle = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;
    idle(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
